// productsSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchFilteredProducts } from '../actions/filterAction';

const productsSlice = createSlice({
  name: 'products2',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
    pagination: undefined,
  },
  reducers: {
    clearFilteredProducts: (state) => {
      state.data = [];
      state.pagination = undefined;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilteredProducts.pending, (state) => {
        state.isLoading = true;
        state.data = [];

      })
      .addCase(fetchFilteredProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        // تأكد أن state.data دائماً array
        if (Array.isArray(action.payload)) {
          state.data = action.payload;
          state.pagination = undefined;
        } else if (action.payload && typeof action.payload === 'object') {
          state.data = Array.isArray(action.payload.data) ? action.payload.data : [];
          state.pagination = action.payload.pagination;
        } else {
          state.data = [];
          state.pagination = undefined;
        }
      })
      .addCase(fetchFilteredProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default productsSlice.reducer;
export const { clearFilteredProducts } = productsSlice.actions;
